import * as t from "io-ts";

export const DispatchNotificationCreateRequestCodec = t.intersection([
  t.type({
    overrideCooldown: t.boolean,
    overrideQuiteHours: t.boolean,
  }),
  t.partial({}),
]);

export type DispatchNotificationCreateRequest = t.TypeOf<typeof DispatchNotificationCreateRequestCodec>;

export const DispatchNotificationBatchCreateRequestCodec = t.intersection([
  t.type({
    dispatchIds: t.array(t.string),
    overrideCooldown: t.boolean,
    overrideQuiteHours: t.boolean,
  }),
  t.partial({}),
]);

export type DispatchNotificationBatchCreateRequest = t.TypeOf<typeof DispatchNotificationBatchCreateRequestCodec>;

export const DispatchNotificationPreviewRequestCodec = t.intersection([
  t.type({
    dispatchIds: t.array(t.string),
  }),
  t.partial({}),
]);

export type DispatchNotificationPreviewRequest = t.TypeOf<typeof DispatchNotificationPreviewRequestCodec>;

export const DispatchNotificationResultCodec = t.intersection([
  t.type({
    status: t.string,
  }),
  t.partial({
    dispatchNotificationId: t.string,
    notificationId: t.string,
    driverId: t.string,
    driverName: t.string,
    skipReason: t.string,
    nextAllowedAtDttm: t.number,
  }),
]);

export type DispatchNotificationOverrideFlags = {
  cooldown: boolean;
  quiteHours: boolean;
};

export type DispatchNotificationResult = t.TypeOf<typeof DispatchNotificationResultCodec>;

export const DispatchNotificationDecisionCodec = t.intersection([
  t.type({
    decision: t.string,
  }),
  t.partial({
    driverId: t.string,
    driverName: t.string,
    skipReason: t.string,
    nextAllowedAtDttm: t.number,
  }),
]);

export type DispatchNotificationDecision = t.TypeOf<typeof DispatchNotificationDecisionCodec>;

export const DispatchNotificationCreateResponseCodec = t.intersection([
  t.type({
    dispatchId: t.string,
    result: DispatchNotificationResultCodec,
    queued: t.number,
    skipped: t.number,
    failed: t.number,
  }),
  t.partial({}),
]);

export type DispatchNotificationCreateResponse = t.TypeOf<typeof DispatchNotificationCreateResponseCodec>;

export const DispatchNotificationBatchCreateResponseResultCodec = t.intersection([
  t.type({
    dispatchId: t.string,
    result: DispatchNotificationResultCodec,
  }),
  t.partial({}),
]);

export type DispatchNotificationBatchCreateResponseResult = t.TypeOf<typeof DispatchNotificationBatchCreateResponseResultCodec>;

export const DispatchNotificationBatchCreateResponseCodec = t.intersection([
  t.type({
    results: t.array(DispatchNotificationBatchCreateResponseResultCodec),
    queued: t.number,
    skipped: t.number,
    failed: t.number,
  }),
  t.partial({}),
]);

export type DispatchNotificationBatchCreateResponse = t.TypeOf<typeof DispatchNotificationBatchCreateResponseCodec>;

export const DispatchNotificationPreviewResponseResultCodec = t.intersection([
  t.type({
    dispatchId: t.string,
    decision: DispatchNotificationDecisionCodec,
  }),
  t.partial({}),
]);

export type DispatchNotificationPreviewResponseResult = t.TypeOf<typeof DispatchNotificationPreviewResponseResultCodec>;

export const DispatchNotificationPreviewResponseCodec = t.intersection([
  t.type({
    results: t.array(DispatchNotificationPreviewResponseResultCodec),
    allow: t.number,
    skip: t.number,
  }),
  t.partial({}),
]);

export type DispatchNotificationPreviewResponse = t.TypeOf<typeof DispatchNotificationPreviewResponseCodec>;

